<template>
  <div class="whitespace-nowrap">
    <div class="flex items-center gap-2 w-full">
      <div class="button-group text-sm w-full" v-auto-animate>
        <button class="min-w-16 flex-1" v-for="time in availableTimes" :key="time" :class="{ 'active': time === fat.preferredTime, '!font-normal': time !== fat.preferredTime }" @click="fat.setPreferredTimeWithOffset(time, !isAllDay ? 90 : 0)">
          {{ time }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const fat = useFatStore()
const dayjs = useDayjs()
const timesLimit = ref(5)

const times = [
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
  '23:00',
]

// Check if time is all day
const isAllDay = computed(() => '10:00' === fat.startTime && '23:00' === fat.endTime)

// // Change number of available times based on screen size
// const updateTimesLimit = () => {
//   const width = window.innerWidth
//   timesLimit.value = width < 768 ? 5 : 5
// }

// // Update times limit on mounted, with resize changes
// onMounted(() => {
//   updateTimesLimit()
//   window.addEventListener('resize', updateTimesLimit)
// })

// // Remove resize listener
// onBeforeUnmount(() => {
//   window.removeEventListener('resize', updateTimesLimit)
// })

// Get available times based on preferred time in FAT store
const availableTimes = computed(() => {
  const limit = timesLimit.value
  const limitBefore = Math.ceil(limit / -2)
  const limitAfter = Math.floor(limit / 2)
  const base = dayjs(fat.preferredTime, 'HH:mm')

  // Sort times by time
  const sorted = times.slice().sort((a, b) =>
    dayjs(a, 'HH:mm').diff(dayjs(b, 'HH:mm'))
  )

  const before = []
  const after = []

  for (const time of sorted) {
    const timeObj = dayjs(time, 'HH:mm')
    if (timeObj.isBefore(base)) {
      before.push(time)
    } else {
      after.push(time)
    }
  }

  // Get up to X before, latest first
  const beforeSlice = before.slice(limitBefore)

  // Get up to X after, earliest first
  const afterSlice = after.slice(0, limitAfter)

  // Combine and fill remaining from nearest (after, then before)
  let combined = [...beforeSlice, ...afterSlice]

  // If we still don't have limit, add more from before or after
  const remaining = limit - combined.length

  if (remaining > 0) {
    // Create a full sorted list of times by proximity to preferredTime
    const fallbackTimes = times
      .filter(t => !combined.includes(t))
      .map(t => ({
        time: t,
        diff: Math.abs(dayjs(t, 'HH:mm').diff(base, 'minute')),
      }))
      .sort((a, b) => a.diff - b.diff)
      .map(t => t.time)

    combined = [...combined, ...fallbackTimes.slice(0, remaining)]
  }

  // Final: ensure we return exactly 5, sorted by actual time
  return combined
    .sort((a, b) => dayjs(a, 'HH:mm').diff(dayjs(b, 'HH:mm')))
    .slice(0, limit)
})
</script>

<style lang="scss" scoped>
.button {
  @apply flex-1 text-center border-2 rounded duration-300 py-1.5 text-sm min-w-16;

  &.active {
    @apply border-coral font-bold;
  }
}
</style>